import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Header from '../Header'
import Messages from '../Messages'
import Sender from '../Sender'
import Dropdown from '../Dropdown'
import ActionLog from '../ActionLog'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import "react-tabs/style/react-tabs.css"
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'
import LoadBehindPreview from '../LoadBehindPreview'

const flexContainer = { height: '100%', display: 'flex', flexFlow: 'column' }
const flexExpand = { flex: 2, overflow: 'auto' }

const Conversation = ({ theme, title, config, subtitle, toggleChat, closeChat, avatarBot, avatarUser, senderPlaceHolder }) => {
  const { embedded, actionLog, headerIcon } = config
  const content = <Content
    avatarBot={avatarBot}
    avatarUser={avatarUser}
    senderPlaceHolder={senderPlaceHolder}
    config={config}
  />

  return (
    <Container className="conversation-container" embedded={embedded} aria-label={title} theme={theme}>
      {!embedded && (
        <Header
          title={title}
          subtitle={subtitle}
          toggleChat={toggleChat}
          closeChat={closeChat}
          theme={theme}
          icon={headerIcon}
        />
      )}

      <div style={flexExpand}>
        {actionLog && (
          <Tabbed>{content}</Tabbed>
        )}

        {!actionLog && content}
      </div>
    </Container>
  )
}

const Tabbed = ({ children }) => (
  <Tabs style={flexContainer}>
    <TabList>
      <Tab>Chat</Tab>
      <Tab>Action Log</Tab>
    </TabList>

    <TabPanel style={flexExpand}>
      {children}
    </TabPanel>
    <TabPanel style={flexExpand}>
      <ActionLog />
    </TabPanel>
  </Tabs>
)

const Content = ({ avatarBot, avatarUser, senderPlaceHolder, config }) => (
  <div style={flexContainer}>
    <Messages avatarBot={avatarBot} avatarUser={avatarUser} config={config} />
    <Dropdown />
    <Sender placeholder={senderPlaceHolder} config={config} />
    <LoadBehindPreview />
  </div>
)

Conversation.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  senderPlaceHolder: PropTypes.string,
  avatarBot: PropTypes.string,
  avatarUser: PropTypes.string,
  toggleChat: PropTypes.func,
  closeChat: PropTypes.func,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string,
    fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  config: PropTypes.shape({
    embedded: PropTypes.bool,
    actionLog: PropTypes.bool,
    headerIcon: PropTypes.string,
  }),
}

export default Conversation

const Container = styled.div`
  background-color: var(--clr-white-to-grey-4, white);
  border-radius: 10px;
  border-color: var(--clr-bot-main, ${props => props.theme.primaryColor});
  border-style: solid;
  border-top: none;
  border-width: ${props => props.embedded ? '0' : '1px'};
  font-weight: ${props => props.theme.fontWeight};
  display: flex;
  flex-flow: column;
  height: ${props => props.embedded ? '100%' : '500px'};


  @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px) {
    border: none;
  }
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Conversation/index.js